import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_AdultMentalHealthRehabilitationTreatmentRequestForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_AdultMentalHealthRehabilitationTreatmentRequestForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    
                    <center><h3>Adult Mental Health Rehabilitation Treatment Request Form</h3></center>
                </p>


                <p className='w-750'>
                    Please complete this form in its entirety — incomplete forms will delay processing.
                    Please return to AmeriHealth Caritas Louisiana BH UM at<br /> <b>1-855-301-5356.</b>
                    For assistance contact, <b>1-855-285-7466.</b>
                </p>

                <p className='w-750'><hr /></p>
                <p className='w-750'><h3>Provider information</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider name:</span>
                            <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group/agency name:</span>
                            <input type='text' id='txtAgencyName' name='txtAgencyName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInNetwork' name='cbInNetwork' className='add-only' value='InNetwork' /> In-network
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOutOfNetwork' name='cbOutOfNetwork' className='add-only' value='OutNetwork' /> Out of network
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCredentialingProcess' name='cbCredentialingProcess' className='add-only' value='InCredentialingProcess' /> In credentialing process
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><b>Provider credential: &nbsp;</b></span>
                            <input type='checkbox' id='cbProviderCredential_1' name='cbProviderCredential_1' className='add-only' value='Md' /> M.D. &nbsp;
                            <input type='checkbox' id='cbProviderCredential_2' name='cbProviderCredential_2' className='add-only' value='Phd' /> Ph.D. &nbsp;
                            <input type='checkbox' id='cbProviderCredential_3' name='cbProviderCredential_3' className='add-only' value='Lmhp' /> LMHP &nbsp;
                            <input type='checkbox' id='cbProviderCredential_4' name='cbProviderCredential_4' className='add-only' value='Lac' /> LAC &nbsp;
                            <input type='checkbox' id='cbProviderCredential_5' name='cbProviderCredential_5' className='add-only' value='Np' /> N.P.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbProviderCredential_6' name='cbProviderCredential_6' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtProviderCredential_6' name='txtProviderCredential_6' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physical address:</span>
                            <input type='text' id='txtPhysicalAddress' name='txtPhysicalAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone:</span>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax:</span>
                            <input type='text' id='txtFax' name='txtFax' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid/provider/NPI #:</span>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact name:</span>
                            <input type='text' id='txtContactName' name='txtContactName' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>DSM diagnosis</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary Dx:</span>
                            <input type='text' id='txtPrimary' name='txtPrimary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Secondary Dx:</span>
                            <input type='text' id='txtSecondary' name='txtSecondary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Medical Dx:</span>
                            <input type='text' id='txtMedical' name='txtMedical' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>If the member has a substance use and/or HIV diagnosis, has consent to release information for these related conditions been obtained?</span><br />
                            <input type='radio' id='rbHIVDiagnosisY' name='rbHIVDiagnosis' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHIVDiagnosisN' name='rbHIVDiagnosis' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbHIVDiagnosisNA' name='rbHIVDiagnosis' className='add-only' value='Na' /> N/A
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>PCP information and collaboration</h3></p>

                <table>
                    <tr>
                        <td>
                            <span><b>Has information been shared with the primary care provider (PCP) or other providers regarding:</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The initial evaluation and treatment plan?</span>
                            <input type='radio' id='rbInitialEvaluationY' name='rbInitialEvaluation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbInitialEvaluationN' name='rbInitialEvaluation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The updated evaluation and treatment plan?</span>
                            <input type='radio' id='rbUpdatedEvaluationY' name='rbUpdatedEvaluation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbUpdatedEvaluationN' name='rbUpdatedEvaluation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other behavioral health providers' names and date last notified; PCP name and date last notified:</span>
                            <input type='text' id='txtBehavioralHealthProviders' name='txtBehavioralHealthProviders' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span>If no, please explain:</span>
                    <textarea id='txtExplain' name='txtExplain' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Symptoms</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidal</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_1' name='cbSuicidal_1' className='add-only' value='1None' /> 1 None</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_2' name='cbSuicidal_2' className='add-only' value='2Low' /> 2 Low</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_3' name='cbSuicidal_3' className='add-only' value='3Moderate' /> 3 Moderate</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_4' name='cbSuicidal_4' className='add-only' value='4High' /> 4 High</td>
                        <td className='w-150'><input type='checkbox' id='cbSuicidal_5' name='cbSuicidal_5' className='add-only' value='5Extreme' /> 5 Extreme</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Homicidal</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_1' name='cbHomicidal_1' className='add-only' value='1None' /> 1 None</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_2' name='cbHomicidal_2' className='add-only' value='2Low' /> 2 Low</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_3' name='cbHomicidal_3' className='add-only' value='3Moderate' /> 3 Moderate</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_4' name='cbHomicidal_4' className='add-only' value='4High' /> 4 High</td>
                        <td className='w-150'><input type='checkbox' id='cbHomicidal_5' name='cbHomicidal_5' className='add-only' value='5Extreme' /> 5 Extreme</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Assault/Violent</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbAssault_1' name='cbAssault_1' className='add-only' value='1None' /> 1 None</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_2' name='cbAssault_2' className='add-only' value='2Low' /> 2 Low</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_3' name='cbAssault_3' className='add-only' value='3Moderate' /> 3 Moderate</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_4' name='cbAssault_4' className='add-only' value='4High' /> 4 High</td>
                        <td className='w-150'><input type='checkbox' id='cbAssault_5' name='cbAssault_5' className='add-only' value='5Extreme' /> 5 Extreme</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is member prescribed medications?</span>
                            <input type='radio' id='rbPrescribedMedicationsY' name='rbPrescribedMedications' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPrescribedMedicationsN' name='rbPrescribedMedications' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Prescribing physicians' names:</span>
                            <input type='text' id='txtPrescribingPhysicians' name='txtPrescribingPhysicians' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is the member compliant with medications? </span>
                            <input type='radio' id='rbMemberCompliantWithMedicationsY' name='rbMemberCompliantWithMedications' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMemberCompliantWithMedicationsN' name='rbMemberCompliantWithMedications' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please list medications and dosages:</span>
                            <input type='text' id='txtDosages' name='txtDosages' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Treatment request: please check services being requested</span></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCommunityPsychiatric' name='cbCommunityPsychiatric' className='add-only' value='CommunityPsychiatricSupportTreatment' /> <b>Community psychiatric support and treatment (CPST):</b>
                            Goal-directed and solution-focused community-based interventions.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_1' name='txtServiceCodeBeingRequested_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_1' name='txtNumberOfUnits_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAssertiveCommunityTreatment' name='cbAssertiveCommunityTreatment' className='add-only' value='AssertiveCommunityTreatment' /> <b>Assertive community treatment (ACT)</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Service code being requested:</span>
                            <input type='text' id='txtServiceCodeBeingRequested_2' name='txtServiceCodeBeingRequested_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Number of units:</span>
                            <input type='text' id='txtNumberOfUnits_2' name='txtNumberOfUnits_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Frequency:</span>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPsychosocialRehabilitation' name='cbPsychosocialRehabilitation' className='add-only' value='PsychosocialRehabilitation' /> <b>Psychosocial rehabilitation (PSR):</b>
                            Services to restore the member to the fullest possible extent as an active and productive member of his or her family and community.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1. PSR individual in the office, # of units per week:</span>
                            <input type='text' id='txtPsrIndividualOffice' name='txtPsrIndividualOffice' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>2. PSR individual in the community, # of units per week:</span>
                            <input type='text' id='txtPsrIndividualCommunity' name='txtPsrIndividualCommunity' className='add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3. PSR group in the office, # of units per week: </span>
                            <input type='text' id='txtPsrGroupOffice' name='txtPsrGroupOffice' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>4. PSR group in the community, # of units per week: </span>
                            <input type='text' id='txtPsrGroupCommunity' name='txtPsrGroupCommunity' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are the requested services part of permanent supportive housing (PSH)?</span>
                            <input type='radio' id='rbPermanentSupportiveHousingY' name='rbPermanentSupportiveHousing' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPermanentSupportiveHousingN' name='rbPermanentSupportiveHousing' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>For all initial requests, please indicate the below</span></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='small'>(Please note that adult mental health rehabilitation services cannot be authorized without the completed assessment and LOCUS).</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has the Adult Mental Health Rehabilitation Assessment been completed? </span>
                            <input type='radio' id='rbMentalHealthRehabilitationY' name='rbMentalHealthRehabilitation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalHealthRehabilitationN' name='rbMentalHealthRehabilitation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            (<span>insert date: </span>
                            <input type='date' id='txtInsertDate' name='txtInsertDate' className='add-only w-180 custom-add-only' /> )
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>If yes, please attach the following: </span><br />
                            <input type='checkbox' id='cbAssessment' name='cbAssessment' className='add-only' value='Assessment' /> Assessment &nbsp;
                            <input type='checkbox' id='cbLocus' name='cbLocus' className='add-only' value='Locus' /> LOCUS &nbsp;
                            <input type='checkbox' id='cbTreatmentPlan' name='cbTreatmentPlan' className='add-only' value='TreatmentPlan' /> Treatment plan &nbsp;
                            (we highly encourage sending a treatment plan)
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span>If no, please explain:</span>
                    <textarea id='txtPleaseExplain' name='txtPleaseExplain' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











